<section class="hiw-section">
  <div class="hiw-bg"></div>

  <div class="reusable-container">
    <div class="hiw-head">
      <div class="hiw-eyebrow">
        <span class="dot"></span>
        How it works
      </div>
      <h2 class="hiw-title">
        Four steps. <span class="accent">Zero friction.</span>
      </h2>
      <p class="hiw-sub">
        From reserving the room to delivering the minutes — every step of your meeting
        lives in one place, so your team never juggles tools again.
      </p>
    </div>

    <div class="hiw-stage">
      <!-- Left: stepper -->
      <div class="hiw-stepper">
        @for (step of steps; let i = $index; track step.key) {
          <button
            type="button"
            class="hiw-step"
            [class.is-active]="active() === i"
            (click)="select(i)">
            <div class="hiw-step-rail">
              <div class="hiw-step-dot">
                <mat-icon>{{ step.icon }}</mat-icon>
              </div>
              @if (i < steps.length - 1) {
                <div class="hiw-step-line"></div>
              }
            </div>
            <div class="hiw-step-body">
              <div class="hiw-step-tag">{{ step.tag }}</div>
              <div class="hiw-step-title">{{ step.title }}</div>
              @if (active() === i) {
                <div class="hiw-step-desc">{{ step.description }}</div>
                <div class="hiw-step-progress"><span></span></div>
              }
            </div>
          </button>
        }
      </div>

      <!-- Right: preview -->
      <div class="hiw-preview">
        <div class="hiw-preview-glow"></div>
        <div class="hiw-preview-frame">
          <div class="hiw-preview-topbar">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
            <div class="hiw-preview-url">app.e-mikutano.go.tz / {{ steps[active()].key }}</div>
          </div>

          @for (step of steps; let i = $index; track step.key) {
            <div class="hiw-preview-slide" [class.is-active]="active() === i">
              <img [src]="step.image" [alt]="step.title" />
            </div>
          }

          <div class="hiw-preview-badge">
            <mat-icon>{{ steps[active()].icon }}</mat-icon>
            {{ steps[active()].tag }}
          </div>

          <div class="hiw-preview-chips">
            @for (chip of steps[active()].highlights; track chip) {
              <span class="hiw-chip">
                <mat-icon>check</mat-icon>
                {{ chip }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
